import { render, staticRenderFns } from "./WBtnValidate.vue?vue&type=template&id=da45c19a&"
import script from "./WBtnValidate.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnValidate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports